export function BackgroundPattern() {
  return (
    <div className="absolute inset-0 -z-10 w-full min-h-full overflow-hidden pointer-events-none">
      <div
        className="absolute inset-0 w-full h-full"
        style={{
          background:
            'radial-gradient(circle at 50% 50%, #FFFFFF 0%, #E6EBFF 100%)',
        }}
      />
      <img
        src="/hatching.webp"
        alt=""
        width={617}
        height={641}
        loading="lazy"
        decoding="async"
        className="absolute bottom-0 -right-4 w-[20rem] h-[20rem] md:w-[35rem] md:h-[35rem] object-contain opacity-5"
      />
    </div>
  )
}
